import angular from 'angular';
import s3FileBrowserComponent from './s3-file-browser.component';

let s3FileBrowserModule = angular.module('s3FileBrowser', []);

s3FileBrowserModule.component('s3FileBrowser', s3FileBrowserComponent);

export default s3FileBrowserModule;




// WEBPACK FOOTER //
// ./client/common/directives/s3-file-browser/s3-file-browser.js